export default __webpack_public_path__ + "static/media/Neophyte's Gloves of the Emissary.2bb57275.jpg";